
import { GridLayoutHeader } from '../../../../../constants';
import { FlexLayout } from '../../../../../components/layout/FlexLayout';
import { TypeModel } from '../models';
import { BreakAnalysisOne } from '../BreakAnalysisOne';
import { TextBox } from '../../../../../components';

// 고장요인별
const Type: GridLayoutHeader<TypeModel, BreakAnalysisOne>[] = [
  {
    id: 'gubunnm',
    text: '기종별(호기구분별)',
    width: 100,
    trail: () => (
      <FlexLayout
        justify="left"
        align="center"
      >
        총계
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.gubunnm}
      </FlexLayout>
    ),
  },
  {
    id: 'cnt',
    text: '고장건수',
    width: 200,
    render: (x) => (
      <TextBox
        textAlign="center"
        value={x.cnt}
      />
    ),
  },
];

export default Type;
